import { EdgeFinish, FenixVariant, LegsThickness, TopFinish, TopMaterial } from '../__generated/model/index.js';
/**
 * Attribute selection options with Localizable labels used for option selection and product description.
 */ export const EDGE_FINISH_OPTION_MAP = {
    [EdgeFinish.Standard]: {
        value: EdgeFinish.Standard,
        img: '/images/edges/none.webp',
        label: {
            id: "TJBHlP",
            message: "Standard"
        }
    },
    [EdgeFinish.Facet]: {
        value: EdgeFinish.Facet,
        img: '/images/edges/facet.webp',
        label: {
            id: "mRPMSw",
            message: "Facet"
        }
    },
    [EdgeFinish.Round]: {
        value: EdgeFinish.Round,
        img: '/images/edges/round.webp',
        label: {
            id: "LeIKtN",
            message: "Round"
        }
    }
};
export const EDGE_FINISH_OPTIONS = [
    EDGE_FINISH_OPTION_MAP[EdgeFinish.Standard],
    EDGE_FINISH_OPTION_MAP[EdgeFinish.Facet],
    EDGE_FINISH_OPTION_MAP[EdgeFinish.Round]
];
export const FENIX_VARIANT_OPTION_MAP = {
    [FenixVariant.Solid]: {
        value: FenixVariant.Solid,
        img: '/images/materials/fenix-solid.webp',
        label: {
            id: "5bi1la",
            message: "Solid"
        }
    },
    [FenixVariant.Birch]: {
        value: FenixVariant.Birch,
        img: '/images/materials/fenix-birch.webp',
        label: {
            id: "zD4wCd",
            message: "Birch"
        }
    },
    // never displayed as an option, used when the top material is not Fenix
    [FenixVariant.None]: {
        value: FenixVariant.None,
        img: '',
        label: ''
    }
};
export const FENIX_VARIANT_OPTIONS = [
    FENIX_VARIANT_OPTION_MAP[FenixVariant.Solid],
    FENIX_VARIANT_OPTION_MAP[FenixVariant.Birch]
];
export const LEG_THICKNESS_OPTION_MAP = {
    [LegsThickness.Thick]: {
        value: LegsThickness.Thick,
        img: '/images/legs/thick.webp',
        label: {
            id: "JwqAmu",
            message: "Thick"
        }
    },
    [LegsThickness.Thin]: {
        value: LegsThickness.Thin,
        img: '/images/legs/thin.webp',
        label: {
            id: "RGjFMI",
            message: "Thin"
        }
    }
};
export const LEG_THICKNESS_OPTIONS = [
    LEG_THICKNESS_OPTION_MAP[LegsThickness.Thick],
    LEG_THICKNESS_OPTION_MAP[LegsThickness.Thin]
];
export const TOP_MATERIAL_OPTION_MAP = {
    [TopMaterial.SolidOak]: {
        value: TopMaterial.SolidOak,
        img: '/images/materials/oak.webp',
        label: {
            id: "3duTE9",
            message: "Solid Oak"
        }
    },
    [TopMaterial.Ceramic]: {
        value: TopMaterial.Ceramic,
        img: '/images/materials/ceramic.webp',
        label: {
            id: "hnm4NG",
            message: "Ceramic"
        }
    },
    [TopMaterial.Fenix]: {
        value: TopMaterial.Fenix,
        img: '/images/materials/fenix.webp',
        label: {
            id: "NeiaVo",
            message: "Fenix"
        }
    }
};
export const TOP_MATERIAL_OPTIONS = [
    TOP_MATERIAL_OPTION_MAP[TopMaterial.SolidOak],
    TOP_MATERIAL_OPTION_MAP[TopMaterial.Ceramic],
    TOP_MATERIAL_OPTION_MAP[TopMaterial.Fenix]
];
export const TOP_FINISH_OPTION_MAP = {
    [TopFinish.NewOak]: {
        value: TopFinish.NewOak,
        img: '/images/finishes/new-oak.webp',
        label: {
            id: "CHdmgP",
            message: "New Oak"
        }
    },
    [TopFinish.LivedOak]: {
        value: TopFinish.LivedOak,
        img: '/images/finishes/lived-oak.webp',
        label: {
            id: "BapMdc",
            message: "Lived Oak"
        }
    },
    [TopFinish.RefinedOak]: {
        value: TopFinish.RefinedOak,
        img: '/images/finishes/refined-oak.webp',
        label: {
            id: "lKxmga",
            message: "Refined Oak"
        }
    },
    // never displayed as an option, used when the top material is not Solid Oak
    [TopFinish.None]: {
        value: TopFinish.None,
        img: '',
        label: ''
    }
};
export const TOP_FINISH_OPTIONS = [
    TOP_FINISH_OPTION_MAP[TopFinish.NewOak],
    TOP_FINISH_OPTION_MAP[TopFinish.LivedOak],
    TOP_FINISH_OPTION_MAP[TopFinish.RefinedOak]
];

//# sourceMappingURL=options.js.map